enum WorkspaceProjectBlockPlantingParamExclusion {
  necromass = 'necromass',
  tree_roots = 'tree_roots',
  bole_and_crown = 'bole_and_crown',
}

export default WorkspaceProjectBlockPlantingParamExclusion
